import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Icon from "components/icons";
import { round } from "lodash";

const StarWrapper = styled.div`
  display: flex;

  svg {
    width: 14px;
    height: 14px;
  }
`;

function Stars(props) {
  const { score } = props;
  const roundedScore = round(parseFloat(score));

  const renderStarRating = () => {
    if (roundedScore === 5) {
      return (
        <StarWrapper>
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
        </StarWrapper>
      );
    }
    if (roundedScore === 4) {
      return (
        <StarWrapper>
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#E0E3E0" />
        </StarWrapper>
      );
    }
    if (roundedScore === 3) {
      return (
        <StarWrapper>
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
        </StarWrapper>
      );
    }

    if (roundedScore === 2) {
      return (
        <StarWrapper>
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
        </StarWrapper>
      );
    }

    if (roundedScore === 1) {
      return (
        <StarWrapper>
          <Icon name="grey-star-14" color="#F5B40C" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
        </StarWrapper>
      );
    }

    if (roundedScore === 0) {
      return (
        <StarWrapper>
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
          <Icon name="grey-star-14" color="#E0E3E0" />
        </StarWrapper>
      );
    }

    return null;
  };
  return <div>{renderStarRating()}</div>;
}

export default Stars;

Stars.propTypes = {
  score: PropTypes.number.isRequired,
};
